export function normalizarItensXml(itensXml = []) {
    return itensXml.map((item) => {
        const produto = item.produto?.[0] || item.produto || item.Produto || null;

        const embalagem = item?.Embalagem || null;
        const imposto = item?.imposto || {};

        return {
            ...item,
            empresaId: item.empresaId || null,
            pedido: !!produto,
            produtoId: item.produtoId || null,
            embalagemId: embalagem?.id || null,
            produtoEmbalagemId: item.produtoEmbalagemId || null,

            Produto: produto || {
                id: item.produtoId || null,
                descricao: item.produtoDescricao || item.descricaoXml || '',
            },

            Embalagem: embalagem || {
                id: item.embalagemId || null,
                descricao: item.embalagemDescricao || '',
            },

            produtoDescricao: produto?.descricao || item.produtoDescricao || item.xProd || '',
            embalagemDescricao: embalagem?.descricao || item.embalagemDescricao || '',

            quantidade: Number(item.qCom ?? item.quantidadeComercial ?? item.quantidade ?? 0),
            valorUnitario: Number(item.vUnCom ?? item.valorUnitarioComercial ?? item.valorUnitario ?? 0),
            valorTotal: Number(item.valorTotal ?? 0),

            pesoBruto: item.pesoBrutoCalculado || 0,
            pesoLiquido: item.pesoLiquidoCalculado || 0,

            //impostos
            baseCalculo: imposto?.ICMS?.vBC || 0,
            ipiAliquota: imposto?.IPI?.pIPI || 0,
            ipi: imposto?.IPI?.vIPI || 0,
            fecoepAliquota: imposto?.ICMS?.pFCP || 0,
            fecoep: imposto?.ICMS?.vFCP || 0,
            fecoepST: imposto?.ICMS?.vFCPST || 0,
            icmsAliquota: imposto?.ICMS?.pICMS || 0,
            icms: imposto?.ICMS?.vICMS || 0,
            icmsST: imposto?.ICMS?.vICMSST || 0,
            mva: 0,
            cfopId: item?.cfopId || null,
            CFOPCadastro: item?.CFOPCadastro || null,

            //bases de calculos xml
            vBC: imposto?.ICMS?.vBC || 0,
            vBCFCP: imposto?.ICMS?.vBCFCP || 0,
            vBCFCPST: imposto?.ICMS?.vBCFCPST || 0,
            vBCST: imposto?.ICMS?.vBCST || 0,

            //aliquotas xml
            pFCP: imposto?.ICMS?.pFCP || 0,
            pFCPST: imposto?.ICMS?.pFCPST || 0,
            pICMS: imposto?.ICMS?.pICMS || 0,
            pICMSST: imposto?.ICMS?.pICMSST || 0,
            pRedBC: imposto?.ICMS?.pRedBC || 0,

            // valores xml
            vICMS: imposto?.ICMS?.vICMS || 0,
            vFCP: imposto?.ICMS?.vFCP || 0,
            vFCPST: imposto?.ICMS?.vFCPST || 0,
            vICMSST: imposto?.ICMS?.vICMSST || 0,

            nItem: item?.nItem || null,
            cProd: item.cProd || null,
            cEAN: item.cEAN || null,
            xProd: item.xProd || null,

            NCM: item.NCM || null,
            CEST: item.CEST || null,
            CFOP: item.CFOP || null,

            uCom: item.uCom || null,
            qCom: item.qCom || null,
            vUnCom: item.vUnCom || null,
            uTrib: item.uTrib || null,
            qTrib: item.qTrib || null,
            vUnTrib: item.vUnTrib || null,
            cEANTrib: item.cEANTrib || null,
            vProd: item.vProd || null,
            indTot: item.indTot || null,
            InfAdProd: item.InfAdProd || null,

            codigoFornecedor: item.codigoFornecedor || item.cProd || null,
            codigoBarras: item.codigoBarras || item.cEAN || null,
            descricaoXml: item.descricaoXml || item.xProd || null,

            importadoXml: true,
            localizadoXml: !!item.localizado,
            pendenteXml: !!item.pendente,
            origemLocalizacaoXml: item.origemLocalizacao || null,
            alertasXml: item.alertas || [],
        };
    });
}
